/*
* TODO -- subclass the shape views into coordinate/svg etc
* */

var BaseShapeView = require('./shape');

/*
* PCT_HT_SHRINK:
* Don wants 0.05 but this seems too small (it's always small -- another case for having a line )*
* Update: 9/27: Don says bump to 15
* */
var PCT_HT_SHRINK = 0.15;


module.exports = BaseShapeView.extend({

    // TODO: this would fit better on 'draw end' ... but need to reorganize the draw fn into the shape views classes also ...
    // ( that would need to come first )

    onAfterRender: function() {

        if ( this.options.shapeModel.uiModel.get('isNewlyDrawn') ) { // Should proxy this through the shape model

            var pgRotation = this.shapeModel.pageModel.get('rotation') % 360,
                shrinkTransform = pgRotation === 0 || pgRotation === 180
                    ? 'S1,' + PCT_HT_SHRINK
                    : 'S' + PCT_HT_SHRINK + ',1';

            this.el
                .transform( shrinkTransform )
                .bakeTransform();

        /*
        * Below animation snippet -- we prob don't want but leaving commented out in case
        * Introduces problems with synchronicity but it's funny
        * */

        /*
            var el = this.el;
            var self = this;
            el.animate( { transform:  'S1,' + PCT_HT_SHRINK }, 500, 'bounce', function() {
                el.bakeTransform();
                self.trigger('shape.onAfterBaseScale'); // reposition the handles -- would need to reposition them as well -- if did this would need a new name

            });

        */
        }
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/strikeThrough.js
 ** module id = 310
 ** module chunks = 0
 **/